// src/router/sale.router.ts
import type { RouteRecordRaw } from 'vue-router'

export const saleRoutes: RouteRecordRaw[] = [
  {
    path: 'sale',
    name: 'sale',
    component: () => import('@/views/page/sale/SaleData.vue'),
    meta: { title: 'Sale' },
  },
  {
    path: 'sale/trash',
    name: 'sale-trash',
    component: () => import('@/views/page/sale/SaleData.vue'),
    meta: { title: 'Sale Trash' },
  },
  {
    path: 'sale/create/',
    name: 'sale-create',
    component: () => import('@/views/page/sale/SaleInput.vue'),
    meta: { title: 'Create Sale' },
  },
  {
    path: 'sale/:id/edit',
    name: 'sale-edit',
    component: () => import('@/views/page/sale/SaleInput.vue'),
    meta: { title: 'Edit Sale' },
  },
]
